(function () {
	let tooltips = [];

	document.querySelectorAll("[data-tooltip]").forEach((element) => {
		const text 	= element.dataset.tooltip;
		if (!text) {
			return;
		}

		const product_conditions = element.closest(".product-conditions");
		if (!product_conditions) {
			return;
		}

		const color = element.dataset.color;

		const tooltip = tippy(element, {
			content: text,
			placement: !!window.matchMedia("(max-width: 768px)").matches ? 'bottom' : 'right',
			allowHTML: true,
			theme: "light",
			touch: true,
			appendTo: !!window.matchMedia("(max-width: 768px)").matches ? product_conditions : document.body,
			hideOnClick: false,
			maxWidth: 250,
			ignoreAttributes: true,
			onCreate(instance) {
				instance.popper.style = `--border-color: ${color};`;
			},
		});

		tooltips = [...tooltips, tooltip];
	});

	const throttledChangeTooltipOptions = throttleDebounce.throttle(1000, () => {
		tooltips.forEach(tooltip => {
			tooltip.hide();
		})

		if (!!window.matchMedia("(max-width: 768px)").matches) {
			tooltips.forEach(tooltip => {
				const product_conditions = tooltip.closest(".product-conditions");
				if (!product_conditions) {
					return;
				}

				tooltip.setProps({
					appendTo: product_conditions,
					placement: 'bottom',
				});
			})
		} else {
			tooltips.forEach(tooltip => {
				tooltip.setProps({
					appendTo: document.body,
					placement: 'right',
				});
			})
		}
	});

	window.addEventListener('resize', function() {
		throttledChangeTooltipOptions();
	});
})();

(function() {
	const searchButton = document.querySelector(".live-search-button");
	if (!searchButton) {
		return;
	}

	const searchField = document.querySelector(".live-search-form-field");
	if (!searchField) {
		return;
	}

	searchButton.addEventListener("click", function (event) {
		const value = searchField.value;
		if (value) {
			return;
		}

		if (window.location.pathname === "/collections/all") {
			return;
		}

		window.location.href = "/collections/all";
	}, true);
})();

// Search page - sort by
(function () {
	const searchSection = document.querySelector('.search--section')

	if (!searchSection) return

	const sortTriggerDesktop = searchSection.querySelector('[data-sort-trigger]')
	const sortTriggerMobile = searchSection.querySelector('[data-productgrid-modal-sort]')
	const sortModalContentTemplate = searchSection.querySelector('[data-productgrid-sort-content]')
	const modalContent = document.querySelector('[data-modal-content]')
	const modalContainer = document.querySelector('[data-modal-container]')
	const modalCloseButton = document.querySelector('[data-modal-close]')
	const modalInner = document.querySelector('[data-modal-inner]')

	const openSortModal = () => {
		document.body.classList.add('modal-loaded', 'modal-visible')
		document.documentElement.classList.add('scroll-locked')
		modalInner.classList.add('vertically-centered')
		modalCloseButton.addEventListener('click', closeSortModal)
		modalContainer.addEventListener('click', closeSortModal)
	}

	const closeSortModal = (event) => {
		if (event.target.closest('.modal-inner') && !event.target.closest('[data-modal-close]')) return
		document.body.classList.remove('modal-loaded', 'modal-visible')
		document.documentElement.classList.remove('scroll-locked')
		modalInner.classList.remove('vertically-centered')
		modalContent.innerHTML = ''
		modalCloseButton.removeEventListener('click', closeSortModal)
		modalContainer.removeEventListener('click', closeSortModal)
	}

	const updateSortOption = (sort) => {
		const urlParams = new URLSearchParams(location.search)
		urlParams.set('sort_by', sort)
		location.search = urlParams.toString()
	}

	const handleSortModalContent = () => {
		const clonedSortModalContent = sortModalContentTemplate.cloneNode(true)
		const sortTriggers = clonedSortModalContent.querySelectorAll('[data-productgrid-trigger-sort-button]')
		sortTriggers.forEach(trigger => {
			trigger.onclick = () => {
				updateSortOption(trigger.getAttribute('value'))
			}
		})
		modalContent.append(clonedSortModalContent)
	}

	sortTriggerDesktop.onchange = () => updateSortOption(sortTriggerDesktop.value)
	sortTriggerMobile.onclick = () => {
		openSortModal()
		handleSortModalContent()
	}
})()
